/* SENSEI tema — interakcije bez zavisnosti (vanilla JS) */
(function () {
  "use strict";

  /* ---------------- Mobilni meni ---------------- */
  var menu = document.querySelector("[data-mobile-menu]");
  document.querySelectorAll("[data-menu-open]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (!menu) return;
      menu.classList.add("is-open");
      document.body.style.overflow = "hidden";
    });
  });
  document.querySelectorAll("[data-menu-close]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (!menu) return;
      menu.classList.remove("is-open");
      document.body.style.overflow = "";
    });
  });

  /* ---------------- FAQ ---------------- */
  document.querySelectorAll("[data-faq-q]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var answer = btn.parentElement.nextElementSibling;
      var open = btn.getAttribute("aria-expanded") === "true";
      document.querySelectorAll("[data-faq-q]").forEach(function (other) {
        other.setAttribute("aria-expanded", "false");
        var a = other.parentElement.nextElementSibling;
        if (a) a.classList.remove("is-open");
      });
      if (!open) {
        btn.setAttribute("aria-expanded", "true");
        if (answer) answer.classList.add("is-open");
      }
    });
  });

  /* ---------------- Video recenzije ---------------- */
  var videoCards = document.querySelectorAll("[data-video-card]");
  videoCards.forEach(function (card) {
    card.addEventListener("click", function () {
      var video = card.querySelector("video");
      if (!video) return;
      videoCards.forEach(function (other) {
        if (other !== card) {
          var v = other.querySelector("video");
          if (v) v.pause();
          other.classList.remove("is-playing");
        }
      });
      if (video.paused) {
        video.play();
        card.classList.add("is-playing");
      } else {
        video.pause();
        card.classList.remove("is-playing");
      }
    });
    var v = card.querySelector("video");
    if (v) {
      v.addEventListener("ended", function () {
        card.classList.remove("is-playing");
      });
    }
  });

  /* ---------------- Prikaži sve recenzije ---------------- */
  var reviewsToggle = document.querySelector("[data-reviews-toggle]");
  if (reviewsToggle) {
    reviewsToggle.addEventListener("click", function () {
      var hidden = document.querySelectorAll("[data-review-extra]");
      var expanded = reviewsToggle.dataset.expanded === "true";
      hidden.forEach(function (item) {
        item.classList.toggle("is-hidden", expanded);
      });
      reviewsToggle.dataset.expanded = expanded ? "false" : "true";
      reviewsToggle.textContent = expanded
        ? "Prikaži sve recenzije"
        : "Sakrij recenzije";
    });
  }

  /* ---------------- Galerija proizvoda ---------------- */
  var mainImage = document.querySelector("[data-gallery-main]");
  document.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.full;
      document.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
        t.classList.remove("is-active");
      });
      thumb.classList.add("is-active");
    });
  });

  /* ---------------- Varijante ---------------- */
  var form = document.querySelector("[data-product-form]");
  var variantSelect = document.querySelector("[data-variant-select]");
  if (form && variantSelect) {
    var priceEl = document.querySelector("[data-product-price]");
    var compareEl = document.querySelector("[data-product-compare]");
    var idInput = form.querySelector('input[name="id"]');
    var submitBtn = form.querySelector("[data-add-button]");
    variantSelect.addEventListener("change", function () {
      var opt = variantSelect.selectedOptions[0];
      if (!opt) return;
      if (idInput) idInput.value = opt.value;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        if (opt.dataset.compare) {
          compareEl.textContent = opt.dataset.compare;
          compareEl.classList.remove("hidden");
        } else {
          compareEl.classList.add("hidden");
        }
      }
      var available = opt.dataset.available === "true";
      if (submitBtn) {
        submitBtn.disabled = !available;
        if (!available) submitBtn.textContent = "Nedostupno";
        else refreshAddLabel();
      }
      updateBuyNow();
    });
  }

  /* ---------------- Akcija 1 / 2 komada ---------------- */
  var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
  var packButtons = document.querySelectorAll("[data-pack]");
  var secondBlock = document.querySelector("[data-second-block]");
  var secondMode = "same";

  packButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      packButtons.forEach(function (b) {
        b.classList.remove("is-active");
      });
      btn.classList.add("is-active");
      if (qtyInput) qtyInput.value = btn.dataset.pack;
      if (secondBlock) secondBlock.classList.toggle("hidden", btn.dataset.pack !== "2");
      refreshAddLabel();
      updateBuyNow();
    });
  });

  document.querySelectorAll("[data-second-mode]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.querySelectorAll("[data-second-mode]").forEach(function (b) {
        b.classList.remove("is-active");
      });
      btn.classList.add("is-active");
      secondMode = btn.dataset.secondMode;
      var fields = document.querySelector("[data-second-fields]");
      var note = document.querySelector("[data-second-note]");
      if (fields) fields.classList.toggle("hidden", secondMode !== "different");
      if (note) note.classList.toggle("hidden", secondMode === "different");
      refreshAddLabel();
      updateBuyNow();
    });
  });

  function selectedPack() {
    var active = document.querySelector("[data-pack].is-active");
    return active ? parseInt(active.dataset.pack, 10) : 1;
  }

  /* ---------------- Cropper + pregled ---------------- */
  var cropper = document.querySelector("[data-cropper]");
  var cropImg = cropper ? cropper.querySelector("[data-crop-img]") : null;
  var cropStage = cropper ? cropper.querySelector("[data-crop-stage]") : null;
  var zoomInput = cropper ? cropper.querySelector("[data-crop-zoom]") : null;
  var state = { target: null, file: null, zoom: 1, x: 0, y: 0, baseW: 0, baseH: 0 };

  function openCropper(file, target) {
    if (!cropper || !cropImg) return;
    state.file = file;
    state.target = target;
    var reader = new FileReader();
    reader.onload = function (e) {
      cropImg.onload = function () {
        var size = cropStage.clientWidth;
        var scale = Math.max(size / cropImg.naturalWidth, size / cropImg.naturalHeight);
        state.baseW = cropImg.naturalWidth * scale;
        state.baseH = cropImg.naturalHeight * scale;
        state.zoom = 1;
        state.x = (size - state.baseW) / 2;
        state.y = (size - state.baseH) / 2;
        if (zoomInput) zoomInput.value = "1";
        applyTransform();
      };
      cropImg.src = e.target.result;
      cropper.classList.add("is-open");
      document.body.style.overflow = "hidden";
    };
    reader.readAsDataURL(file);
  }

  function applyTransform() {
    if (!cropImg) return;
    cropImg.style.width = state.baseW * state.zoom + "px";
    cropImg.style.height = state.baseH * state.zoom + "px";
    cropImg.style.left = state.x + "px";
    cropImg.style.top = state.y + "px";
  }

  function closeCropper() {
    if (!cropper) return;
    cropper.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  if (zoomInput) {
    zoomInput.addEventListener("input", function () {
      var size = cropStage.clientWidth;
      var prev = state.zoom;
      state.zoom = parseFloat(zoomInput.value);
      var cx = size / 2;
      state.x = cx - ((cx - state.x) / prev) * state.zoom;
      state.y = cx - ((cx - state.y) / prev) * state.zoom;
      applyTransform();
    });
  }

  if (cropStage) {
    var dragging = false;
    var start = { x: 0, y: 0 };
    cropStage.addEventListener("pointerdown", function (e) {
      dragging = true;
      start.x = e.clientX - state.x;
      start.y = e.clientY - state.y;
      cropStage.setPointerCapture(e.pointerId);
    });
    cropStage.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      state.x = e.clientX - start.x;
      state.y = e.clientY - start.y;
      applyTransform();
    });
    cropStage.addEventListener("pointerup", function () {
      dragging = false;
    });
  }

  var cancelBtn = document.querySelector("[data-crop-cancel]");
  if (cancelBtn) cancelBtn.addEventListener("click", closeCropper);

  var confirmBtn = document.querySelector("[data-crop-confirm]");
  if (confirmBtn) {
    confirmBtn.addEventListener("click", function () {
      var out = 900;
      var size = cropStage.clientWidth;
      var canvas = document.createElement("canvas");
      canvas.width = out;
      canvas.height = out;
      var ctx = canvas.getContext("2d");
      var ratio = out / size;
      ctx.drawImage(
        cropImg,
        state.x * ratio,
        state.y * ratio,
        state.baseW * state.zoom * ratio,
        state.baseH * state.zoom * ratio
      );
      canvas.toBlob(
        function (blob) {
          var name = (state.file.name || "slika").replace(/\.[^.]+$/, "") + "-crop.jpg";
          var cropped = new File([blob], name, { type: "image/jpeg" });
          applyCropped(state.target, cropped, canvas.toDataURL("image/jpeg", 0.9));
          closeCropper();
        },
        "image/jpeg",
        0.9
      );
    });
  }

  function applyCropped(target, file, dataUrl) {
    var wrap = document.querySelector('[data-upload="' + target + '"]');
    if (!wrap) return;
    var hiddenInput = wrap.querySelector("[data-upload-input]");
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      hiddenInput.files = dt.files;
    } catch (err) {
      /* stariji browseri: original ostaje */
    }
    var preview = wrap.querySelector("[data-upload-preview]");
    if (preview) preview.classList.remove("hidden");
    wrap.querySelectorAll("[data-upload-art]").forEach(function (img) {
      img.src = dataUrl;
    });
    var nameEl = wrap.querySelector("[data-upload-name]");
    if (nameEl) nameEl.textContent = file.name;
    var label = wrap.querySelector("[data-upload-label]");
    if (label) label.textContent = "Promeni sliku";
    wrap.dataset.hasImage = "true";
    refreshAddLabel();
  }

  document.querySelectorAll("[data-upload]").forEach(function (wrap) {
    var picker = wrap.querySelector("[data-upload-picker]");
    if (picker) {
      picker.addEventListener("change", function (e) {
        var file = e.target.files && e.target.files[0];
        e.target.value = "";
        if (file) openCropper(file, wrap.dataset.upload);
      });
    }
    var recrop = wrap.querySelector("[data-upload-recrop]");
    if (recrop) {
      recrop.addEventListener("click", function () {
        var input = wrap.querySelector("[data-upload-input]");
        if (input && input.files && input.files[0]) {
          openCropper(input.files[0], wrap.dataset.upload);
        }
      });
    }
    var remove = wrap.querySelector("[data-upload-remove]");
    if (remove) {
      remove.addEventListener("click", function () {
        var input = wrap.querySelector("[data-upload-input]");
        if (input) input.value = "";
        wrap.dataset.hasImage = "false";
        var preview = wrap.querySelector("[data-upload-preview]");
        if (preview) preview.classList.add("hidden");
        var label = wrap.querySelector("[data-upload-label]");
        if (label) label.textContent = "Izaberi sliku";
        refreshAddLabel();
      });
    }
  });

  /* ---------------- Dugme „Dodaj u korpu" ---------------- */
  var addBtn = document.querySelector("[data-add-button]");
  var personalized = form && form.dataset.personalized === "true";

  function firstImageReady() {
    var wrap = document.querySelector('[data-upload="1"]');
    return !wrap || wrap.dataset.hasImage === "true";
  }
  function secondImageReady() {
    if (secondMode !== "different" || selectedPack() !== 2) return true;
    var wrap = document.querySelector('[data-upload="2"]');
    return !wrap || wrap.dataset.hasImage === "true";
  }

  function refreshAddLabel() {
    if (!addBtn || !personalized) return;
    if (!firstImageReady()) {
      addBtn.disabled = true;
      addBtn.textContent = "Prvo izaberite sliku";
      return;
    }
    if (!secondImageReady()) {
      addBtn.disabled = true;
      addBtn.textContent = "Dodajte sliku za drugi komad";
      return;
    }
    addBtn.disabled = false;
    addBtn.textContent = "Dodaj u korpu (" + selectedPack() + ")";
  }
  refreshAddLabel();

  /* ---------------- Kupi odmah ---------------- */
  var buyNow = document.querySelector("[data-buy-now]");
  function updateBuyNow() {
    if (!buyNow) return;
    var separate = personalized && selectedPack() === 2 && secondMode === "different";
    buyNow.classList.toggle("hidden", separate);
    var note = document.querySelector("[data-buy-note]");
    if (note) note.classList.toggle("hidden", !separate);
    if (personalized && selectedPack() === 2) {
      buyNow.textContent = "Kupi odmah — 2 komada";
    } else {
      buyNow.textContent = "Kupi odmah";
    }
  }
  updateBuyNow();

  if (buyNow && form) {
    buyNow.addEventListener("click", function (e) {
      e.preventDefault();

      // Ako su čekirani dodatni ulošci, obe stavke idu u korpu pa tek onda na plaćanje.
      if (addonIdFrom(form)) {
        buyNow.disabled = true;
        var data = new FormData(form);
        data.delete("checkout");
        fetch((window.SENSEI.routes.cartAdd || "/cart/add") + ".js", { method: "POST", body: data })
          .then(function (r) {
            if (!r.ok) throw new Error("add failed");
            return addAddonFrom(form);
          })
          .then(function () {
            window.location.href = "/checkout";
          })
          .catch(function () {
            buyNow.disabled = false;
            form.submit();
          });
        return;
      }

      var checkoutInput = form.querySelector('[name="checkout"]');
      if (!checkoutInput) {
        checkoutInput = document.createElement("input");
        checkoutInput.type = "hidden";
        checkoutInput.name = "checkout";
        checkoutInput.value = "1";
        form.appendChild(checkoutInput);
      }
      form.submit();
    });
  }

  /* -------- Dodatna ponuda (npr. zamenski ulošci) — važi za SVE načine kupovine -------- */
  function addonIdFrom(f) {
    var t = f ? f.querySelector("[data-addon-toggle]") : null;
    var v = f ? f.querySelector("[data-addon-variant]") : null;
    return t && t.checked && v && v.value ? Number(v.value) : null;
  }
  function addAddonFrom(f) {
    var id = addonIdFrom(f);
    if (!id) return Promise.resolve();
    return fetch((window.SENSEI.routes.cartAdd || "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    });
  }

  /* -------- Dva različita komada: drugi komad kao odvojena linija -------- */
  if (form) {
    form.addEventListener("submit", function (e) {
      var separate = personalized && selectedPack() === 2 && secondMode === "different";
      if (!separate) return;
      e.preventDefault();
      if (qtyInput) qtyInput.value = "1";
      var data1 = new FormData(form);
      var second = document.querySelector("[data-second-fields]");
      var data2 = new FormData(form);
      data2.set("quantity", "1");
      if (second) {
        var scent2 = second.querySelector("[data-second-scent]");
        if (scent2) data2.set("properties[Miris]", scent2.value);
        var color2 = second.querySelector("[data-color-input]");
        if (color2 && color2.value) data2.set("properties[Boja]", color2.value);
        var file2 = document.querySelector('[data-upload="2"] [data-upload-input]');
        if (file2 && file2.files && file2.files[0]) {
          data2.set("properties[Slika]", file2.files[0]);
        }
      }
      data2.delete("checkout");
      data1.delete("checkout");
      var add = window.SENSEI.routes.cartAdd;
      fetch(add, { method: "POST", body: data1 })
        .then(function () {
          return fetch(add, { method: "POST", body: data2 });
        })
        .then(function () {
          return addAddonFrom(form);
        })
        .then(function () {
          if (window.SENSEI.openCartDrawer) return window.SENSEI.openCartDrawer();
          window.location.href = window.SENSEI.routes.cart;
        })
        .catch(function () {
          window.location.href = window.SENSEI.routes.cart;
        });
    });
  }
})();

/* ============================================================
   KORPA SA STRANE (drawer)
   ============================================================ */
(function () {
  var drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  var routes = (window.SENSEI && window.SENSEI.routes) || {};
  var addUrl = (routes.cartAdd || "/cart/add") + ".js";
  var changeUrl = (routes.cartChange || "/cart/change") + ".js";
  var cartUrl = routes.cart || "/cart";

  function openDrawer() {
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-open");
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-open");
  }

  function setBusy(state) {
    drawer.classList.toggle("is-busy", state);
  }

  function syncHeaderCount() {
    var badge = drawer.querySelector(".cart-drawer__count");
    if (!badge) return;
    var text = badge.textContent.replace(/[()\s]/g, "");
    document.querySelectorAll(".cart-link").forEach(function (el) {
      el.textContent = "Korpa (" + text + ")";
    });
  }

  function refresh() {
    return fetch(window.location.pathname + "?sections=cart-drawer", {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data["cart-drawer"];
        if (!html) return;
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var fresh = tmp.querySelector("[data-cart-drawer]");
        if (!fresh) return;
        drawer.innerHTML = fresh.innerHTML;
        syncHeaderCount();
      });
  }

  function changeLine(line, quantity) {
    setBusy(true);
    return fetch(changeUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { return refresh(); })
      .catch(function () { window.location.href = cartUrl; })
      .then(function () { setBusy(false); });
  }

  /* ---- otvaranje iz headera ---- */
  document.addEventListener("click", function (e) {
    var link = e.target.closest ? e.target.closest(".cart-link") : null;
    if (!link) return;
    e.preventDefault();
    refresh().then(openDrawer);
  });

  /* ---- klikovi unutar drawer-a ---- */
  drawer.addEventListener("click", function (e) {
    if (!e.target.closest) return;

    if (e.target.closest("[data-cart-close]")) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var removeBtn = e.target.closest("[data-cart-remove]");
    if (removeBtn) {
      e.preventDefault();
      var lineEl = removeBtn.closest("[data-line-index]");
      if (lineEl) changeLine(parseInt(lineEl.dataset.lineIndex, 10), 0);
      return;
    }

    var stepBtn = e.target.closest("[data-qty-step]");
    if (stepBtn) {
      e.preventDefault();
      var row = stepBtn.closest("[data-line-index]");
      var input = row ? row.querySelector("[data-qty-input]") : null;
      if (!row || !input) return;
      var next = parseInt(input.value, 10) + parseInt(stepBtn.dataset.qtyStep, 10);
      if (next < 0) next = 0;
      changeLine(parseInt(row.dataset.lineIndex, 10), next);
    }
  });

  drawer.addEventListener("change", function (e) {
    var input = e.target.closest ? e.target.closest("[data-qty-input]") : null;
    if (!input) return;
    var row = input.closest("[data-line-index]");
    if (!row) return;
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < 0) value = 1;
    changeLine(parseInt(row.dataset.lineIndex, 10), value);
  });

  /* ---- dodatna ponuda: prikaži izbor mirisa kad se čekira ---- */
  document.addEventListener("change", function (e) {
    var toggle = e.target.closest ? e.target.closest("[data-addon-toggle]") : null;
    if (!toggle) return;
    var block = toggle.closest("[data-addon-block]");
    var fields = block ? block.querySelector("[data-addon-fields]") : null;
    if (fields) fields.classList.toggle("hidden", !toggle.checked);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
  });

  /* ---- dodavanje u korpu bez napuštanja stranice ---- */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (e.defaultPrevented) return;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.querySelector('[name="checkout"]')) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Dodajem…"; }

    var addonToggle = form.querySelector("[data-addon-toggle]");
    var addonVariant = form.querySelector("[data-addon-variant]");
    var addonId =
      addonToggle && addonToggle.checked && addonVariant && addonVariant.value
        ? addonVariant.value
        : null;

    fetch(addUrl, { method: "POST", body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        if (!addonId) return null;
        return fetch(addUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(addonId), quantity: 1 }] })
        });
      })
      .then(function () {
        return refresh();
      })
      .then(openDrawer)
      .catch(function () { form.submit(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  });

  /* ---- koristi ga i logika za dva različita komada ---- */
  window.SENSEI.openCartDrawer = function () {
    return refresh().then(openDrawer);
  };
})();

/* ============================================================
   IZBOR BOJE KUĆIŠTA (personalizovani proizvod)
   ============================================================ */
(function () {
  document.addEventListener("click", function (e) {
    var sw = e.target.closest ? e.target.closest("[data-color-swatch]") : null;
    if (!sw) return;
    var block = sw.closest("[data-color-block]");
    if (!block) return;

    block.querySelectorAll("[data-color-swatch]").forEach(function (b) {
      b.classList.remove("is-active");
      b.setAttribute("aria-pressed", "false");
    });
    sw.classList.add("is-active");
    sw.setAttribute("aria-pressed", "true");

    var name = sw.getAttribute("data-color") || "";
    var input = block.querySelector("[data-color-input]");
    if (input) input.value = name;
    var label = block.querySelector("[data-color-label]");
    if (label) label.textContent = name;

    applyMockup(sw, block);
  });

  /* ---- pregled u izabranoj boji ---- */
  function applyMockup(sw, block) {
    var url = sw.getAttribute("data-mockup");
    if (!url) return;
    var scope = block.closest("[data-second-fields]")
      ? '[data-upload="2"]'
      : '[data-upload="1"]';
    document.querySelectorAll(scope + " .mockup__base").forEach(function (img) {
      img.src = url;
    });
  }

  /* ---- na učitavanju stranice postavi mockup izabrane boje ---- */
  document.querySelectorAll("[data-color-block]").forEach(function (block) {
    var active = block.querySelector("[data-color-swatch].is-active");
    if (active) applyMockup(active, block);
  });
})();

/* ---------- Prekidač za jezik i državu ---------- */
document.addEventListener("change", function (e) {
  var el = e.target;
  if (el && el.matches && el.matches("[data-loc-select]") && el.form) {
    el.form.submit();
  }
});
